function RequestService ($http)
{
    "ngInject";

    var processRequest = function (url, data, method) {
        method = method ? method.toLowerCase() : 'get';

        if (!url) {
            throw new Error("RequestService Error: 'url' is empty");
        }

        if (method === 'get') {
            return $http.get(url, {
                params: data
            });
        }

        return $http.post(url, data)
    };

    return {
        processRequest: processRequest
    };
}

module.exports = RequestService;